export function createBackendApiFetch(baseApi: string): (path: string, init?: RequestInit) => Promise<Response> {
  let baseUrl: URL;
  try {
    baseUrl = new URL(baseApi);
  } catch {
    throw new Error(`createBackendApiFetch: invalid baseApi URL: "${baseApi}"`);
  }
  if(!['http:', 'https:'].includes(baseUrl.protocol)) {
    throw new Error(`createBackendApiFetch: baseApi must use http or https, got: "${baseApi}"`);
  }
  const origin = baseUrl.origin;

  return (path, init) => {
    if(!path.startsWith('/api')) {
      throw new Error(`backendApiFetch: path must start with "/api", got: "${path}"`);
    }
    const url = new URL(path, origin).toString();
    return fetch(url, { credentials: 'include', ...init });
  };
}

export function backendApiFetch(path: string, init?: RequestInit): Promise<Response> {
  return createBackendApiFetch(WEBSITE_BACKEND_BASE_URL)(path, init);
}
